import * as $ from 'jquery'
import * as Admin_ from './self-assignable goals/admin'
import * as Public_ from './self-assignable goals/public'

export namespace Admin {
	export var defineSelfAppliableGoalChangeEvent = () => {
		$("#isSelfAppliableGoal").change(() => {
				$("[name=eligibleMembershipTypes]").closest("li").css(
					"display", $("#isSelfAppliableGoal").prop("checked") ? "block" : "none"
				)
			}
		)
	}

	export var defineAdminEvents = (cb:(n:Node) => void, params: Admin_.EventDefinerParams) => {
		$( () => new Admin_.EventDefiner(cb, params).define() )
	}
}

export namespace Public {
	export var makeEnrollableLinks = (cb:(n:Node) => void, params:{attribute:string, url:string}) => {
		$(() => Public_.makeEnrollableLinks(params.attribute, params.url))
	}
}



// WEBPACK FOOTER //
// ./src/compliancetracker/selfgoal.ts